import { default as React } from 'react';
import { makeStyles } from '@mui/styles';
import skyStageLogo from './../../static/skyStageLogoSidebar.svg';

const useStyles = makeStyles({
  img: {
    width: 120,
    height: 100,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return <img src={skyStageLogo} alt="SkyStage Logo" className={classes.img} />;
};

export default LogoFull;
